import styled from 'styled-components';
import { Card } from '@minerva-analytics/pantheon';
import { MOBILE, CANDY_RED, PEARL } from '../../theme';

const StyledDiv = styled.div`
  background-color: ${PEARL};
`;

const StyledCard = styled(Card)`
  box-sizing: border-box;
  background-color: ${PEARL};
  max-width: 1024px;
  width: 85%;
  box-shadow: unset;
  display: block;
  margin: 0 auto;
  padding: 3rem 0;

  h1 {
    font-family: 'Lato', sans-serif;
    font-weight: 800;
    @media (max-width: ${MOBILE}) {
      font-size: 1.75rem;
    }
  }

  h2 {
    font-size: 1.5rem;
    color: ${CANDY_RED};
    font-family: 'Oswald', sans-serif;
    letter-spacing: 1.25px;
    text-transform: uppercase;
  }

  p {
    font-family: 'Lato', sans-serif;
    font-size: 1.125rem;
    line-height: 1.875rem;
    @media (max-width: ${MOBILE}) {
      font-size: 1rem;
    }
    span {
      font-weight: 700;
    }
  }
`;

export { StyledCard, StyledDiv };
